import { forwardRef, type Ref, type SVGProps } from "react";
const IconRadioButtonOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="currentColor" d="M16 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4M6 16c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10S6 21.523 6 16"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRadioButtonOutlineSVG);
ForwardRef.displayName = "IconRadioButtonOutline";
export { ForwardRef as IconRadioButtonOutline };
